import React from "react";
import { useHoles } from "../util/db";
import { Table } from "react-bootstrap";
import AdminPageDisplayHolesRow from "./AdminPageDisplayHolesRow";

function AdminPageDisplayHoles() {
  const {
    data: items,
    status: itemsStatus,
    // error: itemsError,
  } = useHoles();

  return (
    <Table responsive className="table mb-0">
      <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Length</th>
          <th>Description</th>
          <th>Par</th>
          <th>Setup Notes</th>
        </tr>
      </thead>
      <tbody>
        {itemsStatus !== "loading" &&
          items &&
          items.length > 0 &&
          items.map((item, index) => (
            <AdminPageDisplayHolesRow item={item} key={index} />
          ))}
        {itemsStatus !== "loading" && items && items.length === 0 && (
          <tr>
            <td colSpan="6" className="text-center py-4">
              No holes found.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

export default AdminPageDisplayHoles;
